import styled from 'styled-components';
import { ContentBanner } from '../../components/ContentBanner';

export const Wrapper = styled(ContentBanner)`
  background-color: #000;
  color: white;
`;
